import styled from "styled-components";
import { variantToColour } from "../../helpers/theme";

const ThemedParagraph = styled.p`
    margin: 0;
    color: ${props => variantToColour({ theme: props.theme, variant: props.variant })};
`;

export default ThemedParagraph;